import { useEffect } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { trackBuyerLaunchEvent } from "../../../constants/automapBuyerLaunchConstants";

export function AdminLaunchNav({ active = "hub" }) {
  const items = [
    { key: "hub", label: "Campañas", href: "/admin/campaigns" },
    { key: "launch", label: "Launch", href: "/admin/campaigns/launch" },
    { key: "readiness", label: "Readiness", href: "/admin/campaigns/launch/readiness" },
    { key: "daily", label: "Daily monitor", href: "/admin/campaigns/launch/daily-monitor" },
    { key: "assets", label: "Assets", href: "/admin/campaigns/launch/assets" },
    { key: "leads", label: "Leads", href: "/admin/campaigns/launch/leads" },
  ];
  return (
    <nav className="admin-console__nav-tabs admin-launch-nav">
      {items.map((item) => (
        <Link key={item.key} to={item.href} className={active === item.key ? "is-active" : undefined}>
          {item.label}
        </Link>
      ))}
    </nav>
  );
}

export function LaunchShell({ active, title, description, viewEvent, children }) {
  useEffect(() => {
    if (viewEvent) trackBuyerLaunchEvent(viewEvent);
  }, [viewEvent]);

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Buyer Launch" title={title} description={description} />
      <AdminAutomotiveNav active="campaigns" />
      <AdminLaunchNav active={active} />
      <main className="admin-console__main wrap">{children}</main>
    </AdminPageLayout>
  );
}
